// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__g+ISZ","icon":"styles_icon__Snezy","heading":"styles_heading__8VPeB","hint":"styles_hint__L40OA","button":"styles_button__9CaEG"};